import {Inject, Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {
    MX_ASSIGNMENT_COMPONENTS_SERVICE_TOKEN,
    MxAssignmentComponentsService
} from './mx-assignment-components.service';
import {AssignmentResult, MxAssignmentGrid} from './mx-assignment-grid';
import {MxAssignmentGridDialogConfig} from './mx-assignment-grid-dialog-config';

@Injectable({
    providedIn:  'root'
})
export class MxAssignmentGridDialogService {

    private dialogWidth: string = '80%';
    private dialogHeight: string = '85%';

    constructor(
        private dialog: MatDialog,
        @Inject(MX_ASSIGNMENT_COMPONENTS_SERVICE_TOKEN)
        private componentsService: MxAssignmentComponentsService
    ) {
    }

    public openAssignmentDialog(assignmentGridDialogConfig: MxAssignmentGridDialogConfig): void {
        let dialog: MatDialogRef<MxAssignmentGrid>;
        let dialogConfig: MatDialogConfig;
        let assignmentComponent: new () => MxAssignmentGrid;

        if (assignmentGridDialogConfig.assignedItems) {
            assignmentGridDialogConfig.assignedItems = [...assignmentGridDialogConfig.assignedItems];
        }

        dialogConfig = {
            width: this.dialogWidth,
            height: this.dialogHeight,
            panelClass: ['mx-dialog-panel-class', 'mx-dialog-assignment'],
            data: assignmentGridDialogConfig
        };

        assignmentComponent = this.componentsService.getComponent(assignmentGridDialogConfig.componentName);
        dialog = this.dialog.open(assignmentComponent, dialogConfig);

        dialog.afterClosed()
            .subscribe(
                (assignmentResult: AssignmentResult) => {
                    if (!assignmentResult) {
                        return;
                    }
                    let {assignmentConfig, ...assignmentDialogResult} = assignmentResult;
                    if (assignmentConfig.fieldConverter) {
                        assignmentDialogResult.assignedItems = assignmentDialogResult.assignedItems.map(item => {
                            return assignmentConfig.fieldConverter(item);
                        });
                    }
                    if (assignmentGridDialogConfig.callbackAction) {
                        assignmentGridDialogConfig.callbackAction(assignmentDialogResult);
                    }
                }
            );
    }

}
